<template>
  <div class="documents-table-view">
    <themed-table
      :columns="tableColumns"
      :data="documents"
      :pagination="true"
      :per-page-options="[10, 25, 50, 100]"
      :searchable="false"
      :sortable="true"
      hoverable
      bordered
      aria-label="Project documents table"
      @row-click="handleRowClick"
    >
      <!-- Icon Column -->
      <template #column-icon="{ row }">
        <div class="documents-table__icon-cell">
          <img 
            v-if="row.is_image && row.view_url" 
            :src="row.view_url" 
            :alt="row.name"
            class="documents-table__thumbnail"
          />
          <div v-else class="documents-table__file-icon" v-html="row.icon"></div>
        </div>
      </template>

      <!-- Name Column -->
      <template #column-name="{ row }">
        <a 
          href="#" 
          @click.prevent="$emit('preview', row)" 
          class="documents-table__name-link"
          :title="row.name"
        >
          {{ row.name }}
        </a>
      </template>

      <!-- Category Column -->
      <template #column-category_name="{ row }">
        <themed-badge v-if="row.category_name" variant="secondary">
          {{ row.category_name }}
        </themed-badge>
      </template>

      <!-- Actions Column -->
      <template #actions="{ row }">
        <div class="documents-table__actions">
          <button
            @click.stop="$emit('preview', row)"
            class="documents-table__action-button"
            :title="'Preview ' + row.name"
            aria-label="Preview document"
          >
            <theme-icon icon="eye" type="icons" classes="w-4 h-4" />
          </button>

          <button
            @click.stop="$emit('download', row)"
            class="documents-table__action-button"
            :title="'Download ' + row.name"
            aria-label="Download document"
          >
            <theme-icon icon="download" type="icons" classes="w-4 h-4" />
          </button>

          <button
            v-if="canEdit"
            @click.stop="$emit('edit', row)"
            class="documents-table__action-button"
            :title="'Edit ' + row.name"
            aria-label="Edit document"
          >
            <theme-icon icon="edit" type="icons" classes="w-4 h-4" />
          </button>

          <button
            v-if="canDelete"
            @click.stop="$emit('delete', row)"
            class="documents-table__action-button documents-table__action-button--delete"
            :title="'Delete ' + row.name"
            aria-label="Delete document"
          >
            <theme-icon icon="trash" type="icons" classes="w-4 h-4" />
          </button>
        </div>
      </template>
    </themed-table>
  </div>
</template>

<script>
export default {
  name: 'DocumentsTableView',
  
  props: {
    documents: {
      type: Array,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },
  
  computed: {
    tableColumns() {
      return [
        {
          field: 'icon',
          label: '',
          type: 'custom',
          sortable: false,
          width: '60px'
        },
        {
          field: 'name',
          label: 'Name',
          type: 'text',
          sortable: true,
          searchable: true
        },
        {
          field: 'category_name',
          label: 'Category',
          type: 'custom',
          sortable: true,
          searchable: true
        },
        {
          field: 'subcategory_name',
          label: 'Subcategory',
          type: 'text',
          sortable: true,
          searchable: true
        },
        {
          field: 'type',
          label: 'Type',
          type: 'text',
          sortable: true,
          width: '80px'
        },
        {
          field: 'readable_size',
          label: 'Size',
          type: 'text',
          sortable: true,
          width: '100px'
        },
        {
          field: 'uploaded_by_name',
          label: 'Uploaded By',
          type: 'text',
          sortable: true
        },
        {
          field: 'uploaded_at',
          label: 'Uploaded',
          type: 'text',
          sortable: true,
          width: '120px'
        },
        {
          field: 'actions',
          label: 'Actions',
          type: 'actions',
          sortable: false,
          width: '150px'
        }
      ];
    }
  },
  
  methods: {
    handleRowClick({ row }) {
      this.$emit('preview', row);
    }
  }
};
</script>
